import { masters } from "@nexseed/shared";
import { Mail } from "lucide-react";
import { defineMaster, type MasterRow } from "../spec";

/**
 * The seed-production staff an arrival is e-mailed to from its list row (user, 2026-09-26). Only
 * active people are offered there; States (comma-separated, or ALL) put those covering the arrival's
 * State at the top of the picker. A head (user, 2026-10-23) is copied on every e-mail from a State
 * they cover, whoever the desk picks.
 */
export const productionPersonnel = defineMaster({
  key: "production-personnel",
  title: "Production Personnel",
  singular: "Production Personnel",
  legacyName: "Production Personnel",
  description:
    "Who an arrival can be e-mailed to from its list row. Only active people are offered; heads are copied on every e-mail from a State they cover.",
  icon: Mail,
  schema: masters.productionPersonnel.create,
  searchPlaceholder: "Search name, e-mail or state",
  defaultSort: "name",
  listFilter: {
    param: "isHead",
    label: "Role",
    allLabel: "Everyone",
    options: [
      { value: "true", label: "Heads" },
      { value: "false", label: "Personnel" },
    ],
  },
  optionLabel: (r: MasterRow) => String(r.name),
  columns: [
    { id: "name", header: "Name", sortable: true },
    { id: "states", header: "Production states" },
    { id: "email", header: "E-mail", sortable: true },
    { id: "isHead", header: "Head", kind: "bool" },
    { id: "plantCode", header: "Plant code", kind: "mono" },
    { id: "isActive", header: "Status", kind: "status" },
  ],
  fields: [
    { name: "name", label: "Name", type: "text", required: true, colSpan: 2 },
    {
      name: "states",
      label: "Production states",
      type: "text",
      description: "Comma-separated, e.g. Telangana, Andhra Pradesh; or ALL",
      colSpan: 2,
    },
    {
      name: "email",
      label: "E-mail",
      type: "text",
      required: true,
      colSpan: 2,
    },
    {
      name: "plantCode",
      label: "Plant code",
      type: "text",
      transform: "upper",
    },
    {
      name: "isHead",
      label: "Head of production personnel",
      type: "switch",
      description:
        "Copied automatically on every arrival e-mail from a State they cover",
    },
    { name: "isActive", label: "Active", type: "switch" },
  ],
});
